import { TRootState, TTransactionsState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { transactionsAdapter } from './adapter'

const selectState = (state: TRootState): TTransactionsState => state.transactions

const adapterSelectors = transactionsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}